import React, { forwardRef } from 'react';
import BoxBase from '@material-ui/core/Box';

const Box = forwardRef((props, ref) => <BoxBase ref={ref} {...props} />);

export default Box;
